import Link from "next/link";
import { twMerge } from 'tailwind-merge'

export default function BlogCategoryCard({title, iconClasses = "", data = [], linkClasses = "", parentClasses = "", ...otherProps}) {
    return (
        <div className={`pt-[2.125rem] pb-9 px-[1.375rem] rounded-l-[2.688rem] rounded-r-[1.75rem] ${parentClasses}`}
             {...otherProps}>
            <p className="font-bold">
                <i className={`ml-3 ${iconClasses}`} />
                <span>{title}</span>
            </p>
            <ul className="space-y-[1.2rem] mt-8 pr-1">
                {
                    data.map((item, index) => (
                        <li className="truncate max-w-full w-full" key={index}>
                            <Link href={`/blog/${item.slug}`} className={twMerge("text-sm text-pol-light-brown-11 duration-300 hover:text-pol-blue", linkClasses)}>
                                <i className="icon-simple-arrow-left text-xs ml-3 inline-block" />
                                <span>{item.title}</span>
                            </Link>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}
